var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEdit = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#FA6400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3504 5.52557C10.3221 5.49763 10.3069 5.46162 10.2865 5.42922L5.05273 10.6369L7.29192 12.8643L12.5091 7.67322L10.3504 5.52557Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3504 5.52557C10.3221 5.49763 10.3069 5.46162 10.2865 5.42922L5.05273 10.6369L7.29192 12.8643L12.5091 7.67322L10.3504 5.52557Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2494 6.01651L11.9721 3.75023L11.0059 4.71174C11.0388 4.73257 11.074 4.74727 11.1031 4.77642L13.2614 6.92334L14.2494 6.01651Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2494 6.01651L11.9721 3.75023L11.0059 4.71174C11.0388 4.73257 11.074 4.74727 11.1031 4.77642L13.2614 6.92334L14.2494 6.01651Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47048 13.5482L4.39544 11.4831L3.75 14.25L6.47048 13.5482Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47048 13.5482L4.39544 11.4831L3.75 14.25L6.47048 13.5482Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Edit.891d2075.svg";
export { ForwardRef as ReactComponent };